<template lang="pug">
.planboard-calendar(id="planboard-calendar" @scroll.passive="handleScroll")
  ResourcesList(
    :resources="subResources"
    :timeslotHolderWidth="timeslotHolderWidth"
    :scrollPosResourceNames="scrollPosResourceNames"
    )
  Times(
    :resources="subResources"
    :timeslotHolderWidth="timeslotHolderWidth"
    :openingDateTime="planboardData.OpeningDateTime"
    :scrollPosTimes="scrollPosTimes"
    )
  BookingProductCardOverview
</template>
<script>
import { filter } from 'ramda'
import { mapGetters, mapActions } from 'vuex'
import Times from '@/vue/planboard/planboard-calendar/Times.vue'
import ResourcesList from '@/vue/planboard/planboard-calendar/ResourcesList.vue'
import BookingProductCardOverview from '@/vue/planboard/planboard-calendar/BookingProductCardOverview.vue'

export default {
  name: 'PlanboardCalendar',
  components: {
    Times,
    ResourcesList,
    BookingProductCardOverview,
  },
  data() {
    return {
      scrollPosResourceNames: 0,
      scrollPosTimes: 0,
    }
  },
  computed: {
    ...mapGetters('planboardModule', ['planboardData']),
    subResources() {
      return filter(
        r =>
          r.ResourceType === 'SubResource' &&
          r.ParentResourceKey === this.$route.params.resourceGroupKey,
        this.planboardData.Resources,
      )
    },
    timeslotHolderWidth() {
      const timeslotWidth = 220
      const rightMargin = 50

      return this.subResources.length < 8
        ? 8 * timeslotWidth - rightMargin
        : this.subResources.length * timeslotWidth
    },
  },
  methods: {
    ...mapActions('planboardModule', ['hideOverview']),
    handleScroll(event) {
      this.scrollPosResourceNames = event.target.scrollTop
      this.scrollPosTimes = event.target.scrollLeft
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.planboard-calendar
  border-top 1px solid grey400
  background: grey200
  padding-top 30px

  position: absolute
  overflow-y: scroll
  width: 100%
  height: calc(100vh - 190px)
</style>
